export const uiSettings = {
  appName: 'SAITA',
  direction: 'ltr',
  locale: 'en-US',
  fontFamily: "'Vazirmatn', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  colors: {
    primary: '#315C48',
    primaryDark: '#234235',
    primaryLight: '#E7F1EB',
    secondary: '#C1844D',
    accent: '#2F80ED',
    background: '#F7F8F6',
    surface: '#FFFFFF',
    surfaceMuted: '#EEF2EE',
    border: '#D9E1DA',
    textPrimary: '#17221C',
    textSecondary: '#526157',
    textMuted: '#7A867E',
    success: '#2E7D32',
    warning: '#ED9B33',
    error: '#C62828',
    info: '#1976D2'
  },
  radius: {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 12,
    xl: 16
  },
  spacing: {
    pageX: 'clamp(16px, 3vw, 32px)',
    pageY: '24px',
    sectionGap: '24px',
    panelGap: '16px'
  },
  shadows: {
    sm: '0 1px 2px rgba(23, 34, 28, 0.08)',
    md: '0 8px 24px rgba(23, 34, 28, 0.10)',
    lg: '0 16px 40px rgba(23, 34, 28, 0.14)'
  },
  layout: {
    maxContentWidth: 1440,
    sidebarWidth: 320,
    headerHeight: 72
  }
};

export default uiSettings;
